import { createContext } from "react";

const DF_OT0030Context = createContext();

export { DF_OT0030Context };
